// frontend/features/mpc-common/src/features/Bidding/SupplierQuoteDrawer/apiAdapter.ts
import type { BiddingSupplierQuoteTab } from './types';

// ======================== 报价明细导出/导入（M04 供应商端） ========================


/** 导入响应：每个 tab 融合后的行数据 */
export interface ImportQuoteDetailResult {
  quote_details: {
    name: string;
    config_id: number;
    rows: Record<string, unknown>[];
  }[];
}

/**
 * 从 tabs 构建导出请求的 quoteDetails 数组。
 */
export function buildExportQuoteDetails(tabs: BiddingSupplierQuoteTab[]) {
  return tabs.map((tab) => ({
    name:
      tab.demand_category_names?.join(',') ??
      (tab as any).demand_category_name ??
      `Tab-${tab.config_id}`,
    config_id: tab.config_id,
    columns: tab.columns ?? [],
    rows: tab.rows ?? [],
  }));
}

/**
 * 从 tabs 构建导入请求的 configs 数组。
 */
export function buildImportConfigs(tabs: BiddingSupplierQuoteTab[]) {
  return tabs.map((tab) => ({
    name:
      tab.demand_category_names?.join(',') ??
      (tab as any).demand_category_name ??
      `Tab-${tab.config_id}`,
    config_id: tab.config_id,
  }));
}
